import { render, staticRenderFns } from "./principles-section.vue?vue&type=template&id=2d296db1&"
import script from "./principles-section.vue?vue&type=script&lang=js&"
export * from "./principles-section.vue?vue&type=script&lang=js&"
import style0 from "./principles-section.vue?vue&type=style&index=0&id=2d296db1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports